import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { observer, useLocalStore } from 'mobx-react';

import ErrorMessage from '../../interface/ErrorMessage';
import PreloadButton from '../../interface/PreloadButton';
import { Box, Typography, Input } from '@material-ui/core';
import { CloseBtn, Title } from '../UI/Modal';
import SuccessModal from './SuccessModal';
import { RequestStore } from '../../stores';

const ReqForm2 = observer(({ open, onClose }) => {
    const store = useLocalStore(() => new RequestStore());
    const [values, setValues] = useState({ comment: '' });

    // Effects
    useEffect(() => {
        return () => {
            setValues({
                comment: '',
            });
        };
    }, []);

    // Handlers
    const handleChange = e => {
        setValues({
            ...values,
            [e.target.name]: e.target.value,
        });
    };

    const handleSended = () => {
        setValues({
            comment: '',
        });
        onClose();
    };

    const handleSubmit = e => {
        e.preventDefault();

        store.submitForm2(values, handleSended);
    };

    // Renders
    if (store.success) {
        return <SuccessModal open={true} />;
    }

    return (
        <Modal
            isOpen={open}
            onClose={onClose}
            onRequestClose={onClose}
            className="Modal request-modal"
            overlayClassName="Overlay"
            ariaHideApp={false}
        >
            <CloseBtn onClose={onClose} />
            <Title>Арлифт-эксперт</Title>

            {store.errorMessage.length ? <ErrorMessage message={store.errorMessage} /> : null}

            <form onSubmit={handleSubmit}>
                <Box mb={3}>
                    <Typography variant="body2">
                        Если у вас возникли сложности на объекте и требуется экспертное решение, опишите задачу ниже, и мы обязательно
                        поможем.
                    </Typography>
                </Box>

                <Box mb={3}>
                    <Input
                        name="comment"
                        multiline
                        fullWidth
                        rows={5}
                        placeholder="Опишите вашу задачу"
                        value={values.comment}
                        onChange={handleChange}
                    />
                </Box>

                <PreloadButton isLoad={store.loading}>Отправить заявку</PreloadButton>
            </form>
        </Modal>
    );
});

export default ReqForm2;
